import customerOnboarded from './eventMappers/customerOnboarded';
import messageSent from './eventMappers/messageSent';
import messageReceived from './eventMappers/messageReceived';
import searchResultSelected from './eventMappers/searchResultSelected';
import sessionUpdate from './eventMappers/sessionUpdate';
import widgetOpened from './eventMappers/widgetOpened';
import widgetClosed from './eventMappers/widgetClosed';
import quickActionSelected from './eventMappers/quickActionSelected';

/*
 * Map action types to public event names
 *
 * Choose event names carefully as they cannot be changed once used in production.
 * Once they are part of our public API, changing them could break a customer's implementation.
 *
 * Each event map item should return the following object:
 * [ { eventName: ..., eventPayload: ... }]
 */
const publicEventMap = {
  ...customerOnboarded(),
  ...messageSent(),
  ...messageReceived(),
  ...searchResultSelected(),
  ...sessionUpdate(),
  ...widgetOpened(),
  ...widgetClosed(),
  ...quickActionSelected(),
};

export default context => {
  const observers = context.observers;
  return store => next => action => handleAction(store.getState.bind(store), next, action, publicEventMap, observers);
};

function handleAction(getState, next, action, actionEventMapper, observers) {
  if (action && actionEventMapper[action.type]) {
    const analyticsToSend = actionEventMapper[action.type](action);
    if (analyticsToSend) {
      analyticsToSend.forEach(a => handleAnalytic(a, observers));
    }
  }
  return next(action);
}

function handleAnalytic(analytic, observers) {
  const eventName = analytic.eventName;
  if (!eventName) {
    new Error('analytic eventName not specified');
  }
  const fields = analytic.eventPayload || {};

  if (observers.isValidEventName(eventName)) {
    observers.getObservers(eventName).forEach(o => o(fields));
  }
}
